/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Tab_CanceledInputs */

const en_settings_billing_tab_canceled = /** @type {(inputs: Settings_Billing_Tab_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Settings_Billing_Tab_CanceledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_tab_canceled = /** @type {((inputs?: Settings_Billing_Tab_CanceledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Tab_CanceledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_tab_canceled(inputs)
});
export { settings_billing_tab_canceled as "settings.billing.tab_canceled" }